import { Dispatch } from "../../../../store"

interface MapDispatchToProps {}

export const mapDispatchToProps = (
  _dispatch: Dispatch
): MapDispatchToProps => ({})
